import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Page } from "@ui/page/Page";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { ReportsTab } from "./reports/ReportsTab";
import { StatementsTab } from "./reports/StatementsTab";
import { CalendarDays, FileText, Receipt } from "lucide-react";

export type TReportTotal = {
	// total_transfer_fees_amount: number; // fees for successful transfers (settled transfer amount)
	// total_declinet_fees_amount: number; // fees for failed transfers (declined + chargeback + refund_declined)
	// total_refund_fees_amount: number; // fees for refunds (settled refund amount)
	// total_rollings_amount: number; // amount of rollings (if rollings exist for the merchant)
	// totoal_ic_fees_amount: number; // total intercharge fees amount (if intercharge fees exist for the merchant)

	// total_amount: number; // net payable amount after fees
	// settled_amount: number; // total settled transfer amount
	// refund_amount: number; // total settled refund amount
	// failed_amount: number; // total failed transfer amount (declined + chargeback + refund_declined)

	total_net: number;
	total_fees: number;
	total_amount: number;
	total_refunds: number;
	total_chargebacks: number;
	total_oct: number;
	total_rollings: number;
	total_ajustment_in: number;
	total_ajustment_out: number;
	total_release_rollings: number;
};

export type TInitialClient = {
	id: number;
	name: string;
	date?: string;
	merchants: {
		id: number;
		name: string;
	}[];
};

export type TReportFees = {
	merchant_id: number;
	merchant_channel_id: number;
	client: {
		rollings?: {
			activated_from: string;
			data: {
				reserved: number;
				period: number;
				cap: boolean;
				volume: number;
			};
		};
		setup?: {
			activated_from: string;
			data: {
				setup_fee: number;
				monthly_fee: number;
				withdrawal_fee: number;
				fx_fee: number;
				refund_fee: number;
				chargeback_fee: number;
			};
		};
	};
	channel: {
		rates?: {
			activated_from: string;
			data: {
				ic: boolean;
				range: boolean;
				fee: number;
				fee_fixed: number;
				fee_min: number;
				fee_max: number;
				decline_fee: number;
			};
		};
	};
};

export type TReport = {
	project_id?: number;
	mid: number;
	channel_id: number;
	channel_alias?: string;
	channel_name: string;
	currency?: string;
	total_count?: number;
	transfer_count?: number;
	refund_count?: number;
	failed_refund_count?: number;
	failed_transfer_count?: number;
	transfer_amount?: number;
	refund_amount?: number;
	failed_transfer_amount?: number;
	failed_refund_amount?: number;
	total_auth_count?: number;
	pending_auth_count?: number;
	pending_amount?: string;
	settled_count?: number;
	settled_transfer_amount?: string;
	settled_refund_amount?: string;
	error_count?: number;
	net_amount?: string;
	total: Record<string, TReportTotal>;
	// fees?: TReportFees;
};

export type TMerchant = {
	id: number;
	client_id: number;
	merchant_external_id: number | string | null;
	name: string;
	domain: string;
	status: string;
	client_name: string;
	reports: TReport[];
	total?: TReportTotal;
	totals?: Record<string, TReportTotal>;
};

export type TClient = {
	id: number;
	name: string;
	merchants: TMerchant[];
	// total?: TReportTotal;
	totals?: Record<string, TReportTotal>;
};

export const ReportsPage = () => {
	useLocale();
	return (
		<Page label={msg("reports")} description={msg("dailyReportsSettlementStatementsAndExportReadyFinancialData")} icon={<FileText size={20} />}>
			<Tabs variant="modern">
				<TabItem title={msg("daily")} icon={<CalendarDays size={16} />}>
					<ReportsTab />
				</TabItem>
				<TabItem title={msg("statements")} icon={<Receipt size={16} />}>
					<StatementsTab />
				</TabItem>
			</Tabs>
		</Page>
	);
};
